export default __webpack_public_path__ + "static/media/head_2_male.d94f3a0e.png";